module.exports = __webpack_public_path__ + "static/media/logo_onboarding.e300da37.png";